module.exports = __webpack_public_path__ + "static/media/lock.fad00057.svg";